import type { AuthData } from "./auth";
import { getFingerprint } from "../../public/lib/helpers/fingerprint";
import * as AuthApi from "../../apiLoader/auth";
import { sessionStore} from "../../stores/session";
import type { FoojiData } from "../../../types/campaign";
import { AuthFlow } from "./AbstractAuthFlow";
import { get } from "svelte/store";
import { isTestMode } from "../../stores/mode";

export class DefaultAuthFlow implements AuthFlow {
  async start({ channel, foojiData }: { channel: string; foojiData: FoojiData | undefined }) {
    const session = get(sessionStore);
    const searchParams = isTestMode() ? "?👷=🤓" : "";

    const data: AuthData = {
      return_to: `${document.location.origin}${document.location.pathname}${searchParams}`,
      fooji_data: foojiData ?? {},
      client: "microsite",
      fingerprint: getFingerprint(),
      fingerprint_description: window.navigator.userAgent,
      language: session.language
    };
    const { redirect_url: redirectUrl } = await AuthApi.start(channel, data);
    if (!redirectUrl) {
      console.error(`Failed to start ${channel} Auth Flow`);
      return;
    }
    document.location.href = redirectUrl;
  }
}
